module.exports = {"522728001":"斛兴街道","522728107":"龙坪镇","522728108":"边阳镇","522728109":"沫阳镇","522728110":"逢亭镇","522728111":"罗悃镇","522728112":"茂井镇","522728113":"红水河镇","522728114":"木引镇","522728219":"凤亭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522728.json
// module id = 2345
// module chunks = 0